import {
  Breadcrumb,
  CardContainer,
  CompPagination,
  Container,
  ModalAddCC,
  ModalAssign,
  ModalBanEmail,
  ModalChangeOwner,
  ModalEditTicket,
  ModalReceipt,
  RatingButtons,
} from "components";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import React, {
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import {
  FaBan,
  FaCheck,
  FaCheckCircle,
  FaCog,
  FaEdit,
  FaElementor,
  FaFileExcel,
  FaFileImage,
  FaFilePdf,
  FaFilePowerpoint,
  FaFileWord,
  FaFolderOpen,
  FaHandPointRight,
  FaHistory,
  FaMailBulk,
  FaPaperclip,
  FaPeopleArrows,
  FaRegClock,
  FaRegFlag,
  FaRegWindowClose,
  FaReplyAll,
  FaTag,
  FaTicketAlt,
  FaTrash,
  FaUser,
  FaWindowClose,
} from "react-icons/fa";
import { CKEditor } from "ckeditor4-react";
import moment from "moment";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getData, postData } from "actions";
import {
  API_URL_cannedResponse,
  API_URL_createThreadTicket,
  API_URL_emailSetting,
  API_URL_rating,
  API_URL_resendReplyTicket,
  API_URL_ticket,
  base,
} from "constants/api";
import { ticketReducers } from "redux/ticketSlice";
import { cannedResponseReducers } from "redux/cannedResponseSlice";
import axios from "axios";
import { byteToKiloByte } from "utils/byteToKiloByte";
import { removeTicketPrefix } from "utils/removeTicketPrefix";
import { PulseLoader } from "react-spinners";
import { TbArrowsExchange } from "react-icons/tb";
import { Menu, Transition } from "@headlessui/react";
import { AiOutlineCaretDown } from "react-icons/ai";
import { toast } from "react-toastify";
import { AuthContext } from "context/AuthContext";
import { ratingReducers } from "redux/ratingSlice";
import Swal from "sweetalert2";
import { emailSettingReducers } from "redux/emailSettingSlice";
import { capitalAllLetters } from "utils/capitalAllLetters";
import { decodeBase64 } from "utils/baseEnamEmpat";
import { getExtensionFile } from "utils/getExtensionFile";
import { PhotoProvider, PhotoView } from "react-photo-view";

const TicketDetail = () => {
  let { id_ticket } = useParams();
  const location = useLocation();
  const [state, setState] = useState(location.state ? location.state : "");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    datauser,
    updateCountTicket,
    setUpdateCountTicket,
    wsStatusSendReply,
    setWsStatusSendReply,
  } = useContext(AuthContext);

  //Modal
  const [modalEditTicket, setModalEditTicket] = useState(false);
  const [itemModalEditTicket, setItemModalEditTicket] = useState("");
  const [openModalAssign, setOpenModalAssign] = useState(false);
  const [openModalChangeOwner, setOpenModalChangeOwner] = useState(false);
  const [openModalBanEmail, setOpenModalBanEmail] = useState(false);
  const [openModalCC, setOpenModalCC] = useState(false);
  const [openModalReceipt, setOpenModalReceipt] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const [loadingStatus, setLoadingStatus] = useState(false);
  const [ipAddress, setIpAddress] = useState("");
  const [internalnote, setInternalnote] = useState("");
  const [cannedResponseValue, setCannedResponseValue] = useState("");
  const [refreshReply, setRefreshReply] = useState(false);
  const [refreshInternalNote, setRefreshInternalNote] = useState(false);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  // function color dan icon
  function getColorClass(type) {
    switch (type) {
      case "xlsx":
        return "bg-green-200";
      case "XLSX":
        return "bg-green-200";
      case "xls":
        return "bg-green-200";
      case "XLS":
        return "bg-green-200";
      case "ppt":
        return "bg-orange-200";
      case "PPT":
        return "bg-orange-200";
      case "pptx":
        return "bg-orange-200";
      case "PPTX":
        return "bg-orange-200";
      case "docx":
        return "bg-blue-200";
      case "DOCX":
        return "bg-blue-200";
      case "doc":
        return "bg-blue-200";
      case "DOC":
        return "bg-blue-200";
      case "pdf":
        return "bg-red-200";
      case "PDF":
        return "bg-red-200";
      case "png":
        return "bg-violet-200";
      case "PNG":
        return "bg-violet-200";
      case "jpg":
        return "bg-violet-200";
      case "jpeg":
        return "bg-violet-200";
      case "JPG":
        return "bg-violet-200";
      case "JPEG":
        return "bg-violet-200";
      default:
        return "";
    }
  }

  function getIcon(type) {
    switch (type) {
      case "xlsx":
        return <FaFileExcel className="mr-2 bg-" />;
      case "XLSX":
        return <FaFileExcel className="mr-2 bg-" />;
      case "xls":
        return <FaFileExcel className="mr-2" />;
      case "XLS":
        return <FaFileExcel className="mr-2" />;
      case "ppt":
        return <FaFilePowerpoint className="mr-2" />;
      case "PPT":
        return <FaFilePowerpoint className="mr-2" />;
      case "pptx":
        return <FaFilePowerpoint className="mr-2" />;
      case "PPTX":
        return <FaFilePowerpoint className="mr-2" />;
      case "docx":
        return <FaFileWord className="mr-2" />;
      case "DOCX":
        return <FaFileWord className="mr-2" />;
      case "doc":
        return <FaFileWord className="mr-2" />;
      case "DOC":
        return <FaFileWord className="mr-2" />;
      case "pdf":
        return <FaFilePdf className="mr-2" />;
      case "PDF":
        return <FaFilePdf className="mr-2" />;
      case "png":
        return <FaFileImage className="mr-2" />;
      case "jpg":
        return <FaFileImage className="mr-2" />;
      case "jpeg":
        return <FaFileImage className="mr-2" />;
      case "PNG":
        return <FaFileImage className="mr-2" />;
      case "JPG":
        return <FaFileImage className="mr-2" />;
      case "JPEG":
        return <FaFileImage className="mr-2" />;
      default:
        return null; // Tidak ada ikon jika tidak ada jenis yang cocok
    }
  }

  const {
    getTicketResult,
    getCannedResponseResult,
    getRatingResult,
    getEmailSettingResult,
  } = useSelector((state) => ({
    getTicketResult: state.ticket.getTicketResult,
    getTicketLoading: state.ticket.getTicketLoading,
    getCannedResponseResult: state.cannedResponse.getCannedResponseResult,
    getRatingResult: state.rating.getRatingResult,
    getEmailSettingResult: state.emailSetting.getEmailSettingResult,
  }));

  const getEmailSetting = useCallback(
    async (params) => {
      getData(
        API_URL_emailSetting,
        params,
        { dispatch, redux: emailSettingReducers },
        "GET_EMAILSETTING"
      );
    },
    [dispatch]
  );

  const getTicket = useCallback(
    async (params) => {
      getData(
        API_URL_ticket,
        params,
        { dispatch, redux: ticketReducers },
        "GET_TICKET",
        () => {},
        () => {
          navigate("/tickets/inbox");
        }
      );
    },
    [dispatch]
  );

  const getCannedResponse = useCallback(
    async (params) => {
      getData(
        API_URL_cannedResponse,
        params,
        { dispatch, redux: cannedResponseReducers },
        "GET_CANNEDRESPONSE"
      );
    },
    [dispatch]
  );

  const fetchRating = useCallback(
    async (params) => {
      getData(
        API_URL_rating,
        params,
        { dispatch, redux: ratingReducers },
        "GET_RATING"
      );
    },
    [dispatch]
  );

  const fetchEmailSetting = useCallback(() => {
    //get id 1 for setting
    const params = `1/`;
    getEmailSetting(params);
  }, [getEmailSetting]);

  const alertPermissionRestricted = () => {
    toast.warning("Sorry, you don't have permission to perform this action.", {
      position: "top-center",
      autoClose: true,
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };

  const formikReply = useFormik({
    initialValues: {
      body: "",
      files: [],
    },
    validationSchema: Yup.object({
      body: Yup.string().required("Reply Content is required"),
    }),
    onSubmit: (values) => {
      setLoadingSubmit(true);

      // Have permission can post ticket ?
      const permission = datauser.group_permissions;
      const canPostTicket = permission.includes("can_reply_ticket");
      if (!canPostTicket) {
        alertPermissionRestricted();
      } else {
        const formData = new FormData();
        formData.append("title", getTicketResult.results?.title);
        formData.append("ip_address", "0.0.0.0");
        formData.append("is_internal", 0);
        formData.append("body", values.body);
        formData.append("source", 3);
        formData.append("ticket", state.id);
        formData.append("user", datauser.id);
        // Menggunakan values.files untuk mengambil daftar file yang dipilih
        values.files.forEach((file, index) => {
          formData.append(`file_${index}`, file);
        });

        const text_quetion =
          getTicketResult?.results?.source === 8
            ? `This reply will be send to account telegram ${getTicketResult?.results?.client_name}`
            : `This reply will be send to ${
                getTicketResult?.results?.user_email ?? "User"
              }`;

        Swal.fire({
          title: "Please check",
          text: text_quetion,
          icon: "info",
          showCancelButton: true,
          confirmButtonColor: "#15803D",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Send",
          customClass: {
            container: "z-[99999]",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            postData(
              `${API_URL_createThreadTicket}`,
              formData,
              { dispatch, redux: ticketReducers },
              "ADD_TICKET",
              () => {
                formikReply.resetForm();
                formikReply.setFieldValue("body", "");
                setRefreshReply(!refreshReply);
                getTicket(state.id);
                setCannedResponseValue("");
                setLoadingSubmit(false);
              },
              () => {
                setLoadingSubmit(false);
              }
            );
          } else {
            setLoadingSubmit(false);
          }
        });
      }
    },
  });

  const formikInternalNotes = useFormik({
    initialValues: {
      body: internalnote,
    },
    validationSchema: Yup.object({
      body: Yup.string().required("Internal Note is required"),
    }),
    onSubmit: (values) => {
      setLoadingSubmit(true);

      // Have permission can post ticket ?
      const permission = datauser.group_permissions;
      const canPostTicket = permission.includes("can_reply_ticket");
      if (!canPostTicket) {
        alertPermissionRestricted();
      } else {
        const formData = new FormData();
        formData.append("title", getTicketResult.results?.title);
        formData.append("body", values.body);
        formData.append("ip_address", "0.0.0.0");
        formData.append("is_internal", 1);
        formData.append("body", values.body);
        formData.append("source", 3);
        formData.append("ticket", state.id);
        formData.append("user", datauser.id);

        postData(
          `${API_URL_createThreadTicket}`,
          formData,
          { dispatch, redux: ticketReducers },
          "ADD_TICKET",
          () => {
            formikInternalNotes.resetForm();
            formikInternalNotes.setFieldValue("body", "");
            setRefreshInternalNote(!refreshInternalNote);
            getTicket(state.id);
            setLoadingSubmit(false);
          },
          () => {
            setLoadingSubmit(false);
          }
        );
      }
    },
  });

  const toolbarConfig = {
    extraPlugins: "font,colorbutton,colordialog",
    removePlugins: "about,image",
    skin: "moono",
  };

  const handleChangeCanned = (e) => {
    setCannedResponseValue(e.target.value);
    formikReply.setFieldValue("body", e.target.value);
    setRefreshReply(!refreshReply);
  };

  //funtion modal Change Owner
  const handleOpenModalChangeOwner = () => {
    // Have permission can Transfer ticket ?
    const permission = datauser.group_permissions;
    const canTransferTicket = permission.includes("can_transfer_ticket");
    if (!canTransferTicket) {
      alertPermissionRestricted();
    } else {
      setOpenModalChangeOwner(true);
    }
  };
  const handleCloseModalChangeOwner = () => {
    setOpenModalChangeOwner(false);
  };

  //funtion modal Edit Ticket
  const openModalEdit = (value) => {
    // Have permission can edit ticket ?
    const permission = datauser.group_permissions;
    const canEditTicket = permission.includes("can_edit_ticket");
    if (!canEditTicket) {
      alertPermissionRestricted();
    } else {
      setModalEditTicket(true);
      setItemModalEditTicket(value);
    }
  };
  const closeModalEdit = () => {
    setModalEditTicket(false);
  };

  //funtion modal Assign
  const HandleAssign = () => {
    // Have permission can assign ticket ?
    const permission = datauser.group_permissions;
    const canAssignTicket = permission.includes("can_assign_ticket");
    if (!canAssignTicket) {
      alertPermissionRestricted();
    } else {
      setOpenModalAssign(true);
    }
  };
  const HandleCloseAssign = () => {
    setOpenModalAssign(false);
  };

  //function handle cc
  const handleCc = () => {
    setOpenModalCC(true);
  };
  const handleCloseCc = () => {
    setOpenModalCC(false);
  };

  const handleReceipt = () => {
    setOpenModalReceipt(true);
  };
  const handleCloseReceipt = () => {
    setOpenModalReceipt(false);
  };

  //funtion modal Ban Email
  const HandleBanEmail = () => {
    // Have permission can ban ticket ?
    const permission = datauser.group_permissions;
    const canBanTicket = permission.includes("can_ban_email");
    if (!canBanTicket) {
      alertPermissionRestricted();
    } else {
      setOpenModalBanEmail(true);
    }
  };
  const HandleCloseBanEmail = () => {
    setOpenModalBanEmail(false);
  };

  const HandleNotSpam = () => {
    setLoadingStatus(true);

    const data = {
      id: state.id,
      is_spam: 0,
      by_user: datauser.id,
    };

    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "PUT",
      data: data,
      url: API_URL_ticket + state.id + "/",
    })
      .then((response) => {
        setLoadingStatus(false);
        setUpdateCountTicket(!updateCountTicket);
        toast.success("Ticket Set Not Spam Successfully", {
          position: "top-center",
          autoClose: true,
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        handleFetch();
      })
      .catch((error) => {
        setLoadingStatus(false);
        console.log(error);
        handleFetch();
      });
  };

  const HandleDeleteForever = () => {
    Swal.fire({
      title: "Are You Sure?",
      text: "This ticket delete forever ",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#378ecc",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      customClass: {
        container: "z-[99999]",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          headers: {
            Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
          },
          method: "DELETE",
          url: API_URL_ticket + state.id + "/",
        })
          .then((response) => {
            setUpdateCountTicket(!updateCountTicket);
            toast.success("Ticket Delete Successfully", {
              position: "top-center",
              autoClose: true,
              autoClose: 1500,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setTimeout(() => {
              window.history.back();
            }, 1500);
          })
          .catch((error) => {
            console.log(error);
            handleFetch();
          });
      }
    });
  };

  const HandleSurrender = () => {
    Swal.fire({
      title: "Are You Sure?",
      text: "This ticket set to UNASSIGNED ",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#378ecc",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      customClass: {
        container: "z-[99999]",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const data = {
          id: state.id,
          surrender: true,
          by_user: datauser.id,
        };

        axios({
          headers: {
            Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
          },
          data: data,
          method: "PUT",
          url: API_URL_ticket + state.id + "/",
        })
          .then((response) => {
            setUpdateCountTicket(!updateCountTicket);
            toast.success("Surrender Successfully", {
              position: "top-center",
              autoClose: true,
              autoClose: 1500,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            handleFetch();
          })
          .catch((error) => {
            console.log(error);
            handleFetch();
          });
      }
    });
  };

  const handleFetch = () => {
    getTicket(state.id);
  };

  const handlePageClick = ({ selected }) => {
    const newOffset = selected * limit;
    const params = `${state.id}/?limit=${limit}&offset=${newOffset}`;
    setOffset(newOffset);
    setCurrentPage(selected);
    getTicket(params);
  };

  const HandleOpen = () => {
    setLoadingStatus(true);

    const data = {
      id: state.id,
      status: 1,
      closed: 0,
      reopened: 1,
      by_user: datauser.id,
    };
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "PUT",
      data: data,
      url: API_URL_ticket + state.id + "/",
    })
      .then((response) => {
        setLoadingStatus(false);
        setUpdateCountTicket(!updateCountTicket);
        toast.success("Ticket Opened Successfully", {
          position: "top-center",
          autoClose: true,
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        handleFetch();
      })
      .catch((error) => {
        setLoadingStatus(false);
        console.log(error);
        handleFetch();
      });
  };

  const HandleClose = () => {
    // Have permission can close ticket ?
    const permission = datauser.group_permissions;
    const canCloseTicket = permission.includes("can_close_ticket");
    if (!canCloseTicket) {
      alertPermissionRestricted();
    } else {
      setLoadingStatus(true);
      const data = {
        id: state.id,
        status: 3,
        closed: 1,
        reopened: 0,
        by_user: datauser.id,
      };

      axios({
        headers: {
          Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
        },
        method: "PUT",
        data: data,
        url: API_URL_ticket + state.id + "/",
      })
        .then((response) => {
          setLoadingStatus(false);
          setUpdateCountTicket(!updateCountTicket);
          toast.success("Ticket Closed Successfully", {
            position: "top-center",
            autoClose: true,
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          handleFetch();
        })
        .catch((error) => {
          setLoadingStatus(false);
          console.log(error);
          handleFetch();
        });
    }
  };

  const HandleResolved = () => {
    setLoadingStatus(true);

    const data = {
      id: state.id,
      status: 2,
      closed: 0,
      reopened: 0,
      by_user: datauser.id,
    };

    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "PUT",
      data: data,
      url: API_URL_ticket + state.id + "/",
    })
      .then((response) => {
        setLoadingStatus(false);
        setUpdateCountTicket(!updateCountTicket);
        toast.success("Ticket Resolved Successfully", {
          position: "top-center",
          autoClose: true,
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        handleFetch();
      })
      .catch((error) => {
        setLoadingStatus(false);
        console.log(error);
        handleFetch();
      });
  };

  const HandleDeleted = () => {
    // Have permission can delete ticket ?
    const permission = datauser.group_permissions;
    const canDeleteTicket = permission.includes("can_delete_ticket");
    if (!canDeleteTicket) {
      alertPermissionRestricted();
    } else {
      setLoadingStatus(true);

      const data = {
        id: state.id,
        status: 4,
        closed: 0,
        reopened: 0,
        by_user: datauser.id,
      };

      axios({
        headers: {
          Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
        },
        method: "PUT",
        data: data,
        url: API_URL_ticket + state.id + "/",
      })
        .then((response) => {
          setLoadingStatus(false);
          setUpdateCountTicket(!updateCountTicket);
          toast.success("Ticket Deleted Successfully", {
            position: "top-center",
            autoClose: true,
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          handleFetch();
        })
        .catch((error) => {
          setLoadingStatus(false);
          console.log(error);
          handleFetch();
        });
    }
  };

  const HandleSpam = () => {
    setLoadingStatus(true);

    const data = {
      id: state.id,
      is_spam: 1,
      by_user: datauser.id,
    };

    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "PUT",
      data: data,
      url: API_URL_ticket + state.id + "/",
    })
      .then((response) => {
        setLoadingStatus(false);
        setUpdateCountTicket(!updateCountTicket);
        toast.success("Ticket set Spam Successfully", {
          position: "top-center",
          autoClose: true,
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        handleFetch();
      })
      .catch((error) => {
        setLoadingStatus(false);
        console.log(error);
        handleFetch();
      });
  };

  const HandleResend = (id_thread) => {
    setLoadingStatus(true);

    const data = {
      id_ticket: state.id,
      id_thread: id_thread,
    };
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "POST",
      data: data,
      url: API_URL_resendReplyTicket,
    })
      .then((response) => {
        setLoadingStatus(false);
        setUpdateCountTicket(!updateCountTicket);
        toast.success(
          "Resend Reply is being processed. Please wait a moment.",
          {
            position: "top-center",
            autoClose: true,
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
        handleFetch();
      })
      .catch((error) => {
        setLoadingStatus(false);
        console.log(error);
      });
  };

  const HandlePreviewUser = (id) => {
    navigate(`/users/userdirectory/view`, {
      state: {
        item: {
          id,
        },
      },
    });
  };

  // Fungsi untuk memeriksa apakah waktu saat ini lebih dari 5 menit setelah createdAt
  const isMoreThan5MinutesAgo = (createdAt) => {
    const currentTime = new Date();
    const diffInMilliseconds = currentTime - new Date(createdAt);
    const fiveMinutesInMilliseconds = 5 * 60 * 1000; // 5 menit dalam milidetik
    return diffInMilliseconds > fiveMinutesInMilliseconds;
  };

  useEffect(() => {
    if (state !== "") {
      const params = `?limit=${9999999}`;
      getTicket(state.id);
      getCannedResponse(params);
    }
  }, [state]);

  useEffect(() => {
    if (wsStatusSendReply === "failed" || wsStatusSendReply === "success") {
      handleFetch();
      setWsStatusSendReply(false);
    }
  }, [wsStatusSendReply]);

  useEffect(() => {
    if (cannedResponseValue) {
      formikReply.setFieldValue("body", cannedResponseValue);
      setRefreshReply(!refreshReply);
    }
  }, [cannedResponseValue]);

  useEffect(() => {
    fetchRating("1/");
    fetchEmailSetting();
  }, []);

  useEffect(() => {
    if (state === "") {
      if (id_ticket !== undefined) {
        id_ticket = decodeBase64(id_ticket);
        setState({ id: id_ticket });
      } else {
        navigate("/tickets/inbox");
      }
    }
  }, []);

  return (
    <Container>
      <Breadcrumb
        title={"Ticket Detail"}
        excludedPaths={["tickets", id_ticket]}
      />
      {getTicketResult.results === undefined && (
        <div className="fixed inset-0 z-[40] flex justify-center items-center bg-black bg-opacity-30">
          <PulseLoader color="rgb(2 132 199)" size={40} />
        </div>
      )}
      <CardContainer
        icon={<FaTicketAlt className=" text-green-500 h-6 w-6 mr-2" />}
        title={getTicketResult.results?.title}
        className={"md:text-xl font-semibold"}
      >
        <div className="m-4">
          {/* button Bukan Spam */}
          {getTicketResult.results?.is_spam !== 1 && (
            <div className="flex flex-wrap justify-start gap-1 text-sm mb-4">
              <button
                title="Edit identity ticket"
                onClick={() => openModalEdit(getTicketResult.results)}
                className="flex p-1 px-3 items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100 dark:bg-neutral-700 dark:border-neutral-700 text-gray-900 dark:text-white"
              >
                <FaEdit className="text-green-500" /> Edit
              </button>
              <button
                title="Asisign ticket to Agent or Team"
                onClick={() => HandleAssign()}
                className="flex p-1 px-3 items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100 dark:bg-neutral-700 dark:border-neutral-700 text-gray-900 dark:text-white"
              >
                <FaHandPointRight className="text-yellow-500" /> Assign
              </button>
              {getTicketResult.results &&
                getTicketResult.results.assigned_to === datauser.id && (
                  <button
                    title="Agent surrender to resolved ticket, ticket will set to UNASSIGNED"
                    onClick={() => HandleSurrender()}
                    className="flex p-1 px-3 items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100 dark:bg-neutral-700 dark:border-neutral-700 text-gray-900 dark:text-white"
                  >
                    <FaRegFlag className="text-red-500 mr-1" /> Surrender
                  </button>
                )}

              {/* <button className="flex p-1 px-3 items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100 dark:bg-neutral-700 dark:border-neutral-700 text-gray-900 dark:text-white">
                <FaPrint title="Print PDF" className="text-red-500" /> Generate
                PDF
              </button> */}

              <Menu
                as="div"
                className="relative inline-block text-left border rounded  bg-neutral-50 hover:bg-neutral-100 dark:bg-neutral-700 dark:border-neutral-700 text-gray-900 dark:text-white"
              >
                <div title="Change Status Ticket">
                  <Menu.Button className="flex gap-1 p-1 px-3 items-center  shadow-sm ">
                    {loadingStatus ? (
                      <PulseLoader color="#4477CE" size={11} />
                    ) : (
                      <TbArrowsExchange className="text-blue-500" />
                    )}
                    Change Status
                    <AiOutlineCaretDown
                      className="-mr-1 h-3 w-3 text-gray-400"
                      aria-hidden="true"
                    />
                  </Menu.Button>
                </div>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 z-10 mt-2 w-fit origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="py-1">
                      <Menu.Item>
                        <button
                          onClick={() => HandleOpen()}
                          className="flex items-center gap-1 w-full px-4 py-2 text-sm hover:bg-gray-100 text-gray-900"
                        >
                          <FaFolderOpen className="text-red-500" /> Open
                        </button>
                      </Menu.Item>
                      <Menu.Item>
                        <button
                          onClick={() => HandleResolved()}
                          className="flex items-center gap-1 w-full px-4 py-2 text-sm hover:bg-gray-100 text-gray-900"
                        >
                          <FaCheckCircle className="text-green-500" /> Resolved
                        </button>
                      </Menu.Item>
                      <Menu.Item>
                        <button
                          onClick={() => HandleClose()}
                          className="flex items-center gap-1 w-full px-4 py-2 text-sm hover:bg-gray-100 text-gray-900"
                        >
                          <FaCheck className="text-green-500" /> Closed
                        </button>
                      </Menu.Item>
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
              <Menu
                as="div"
                className="relative inline-block text-left border rounded  bg-neutral-50 hover:bg-neutral-100 dark:bg-neutral-700 dark:border-neutral-700 text-gray-900 dark:text-white"
              >
                <div title="More Setting">
                  <Menu.Button className="flex gap-1 p-1 px-3 items-center  shadow-sm  ">
                    {loadingStatus ? (
                      <PulseLoader color="#4477CE" size={11} />
                    ) : (
                      <FaCog className="text-blue-500" />
                    )}
                    More
                    <AiOutlineCaretDown
                      className="-mr-1 h-3 w-3 text-gray-400"
                      aria-hidden="true"
                    />
                  </Menu.Button>
                </div>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 z-10 mt-2 w-fit origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="py-1">
                      <Menu.Item>
                        <button
                          onClick={() => handleOpenModalChangeOwner()}
                          className="flex items-center gap-1 w-[14em] px-4 py-2 text-sm hover:bg-gray-100 text-gray-900"
                        >
                          <FaPeopleArrows className="text-green-800" /> Change
                          owner for ticket
                        </button>
                      </Menu.Item>
                      <Menu.Item>
                        <button
                          onClick={() => HandleDeleted()}
                          className="flex items-center gap-1  w-[14em] px-4  py-2 text-sm hover:bg-gray-100 text-gray-900"
                        >
                          <FaTrash className="text-red-600" /> Deleted ticket
                        </button>
                      </Menu.Item>
                      <Menu.Item>
                        <button
                          onClick={() => HandleSpam()}
                          className="flex items-center gap-1  w-[14em] px-4  py-2 text-sm hover:bg-gray-100 text-gray-900"
                        >
                          <FaRegWindowClose className="text-red-600" /> Spam
                          ticket
                        </button>
                      </Menu.Item>
                      <Menu.Item>
                        <button
                          onClick={() => HandleBanEmail()}
                          className="flex items-center gap-1  w-[14em] px-4  py-2 text-sm hover:bg-gray-100 text-gray-900"
                        >
                          <FaBan className="text-red-700" /> Ban email
                        </button>
                      </Menu.Item>
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>
          )}

          {/* Button Khusus Spam */}
          {getTicketResult.results?.is_spam === 1 && (
            <div className="flex flex-wrap justify-start gap-1 text-sm mb-4">
              <button
                onClick={HandleDeleteForever}
                className="flex p-1 px-3 items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100 dark:bg-neutral-700 dark:border-neutral-700 text-gray-900 dark:text-white"
              >
                <FaTrash className="text-red-500" /> Delete Forever
              </button>

              <button
                onClick={HandleNotSpam}
                className="flex p-1 px-3 items-center text-green-500 rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100 dark:bg-neutral-700 dark:border-neutral-700  dark:text-white"
              >
                <FaCheck /> Not Spam
              </button>
            </div>
          )}

          {/* about ticket */}
          <div
            style={{ backgroundColor: getTicketResult.results?.priority_color }}
            className="drop-shadow  shadow-neutral-400 dark:shadow-neutral-600 shadow-md  px-4 py-4 rounded border-l-4  border-neutral-300 dark:border-neutral-400  text-white dark:text-white mb-4"
          >
            {getTicketResult.results && (
              <div className="grid grid-cols-12">
                <div className="col-span-12 md:col-span-6 lg:col-span-3">
                  <b>SLA Plan: </b>
                  <span>{getTicketResult.results?.sla_name}</span>
                </div>
                <div className="col-span-12 md:col-span-6 lg:col-span-3">
                  <b>Ticket Date: </b>
                  <span>
                    {moment(getTicketResult.results?.created_at).format(
                      "DD/MM/YYYY HH:mm:ss"
                    )}
                  </span>
                </div>
                <div className="col-span-12 md:col-span-6 lg:col-span-3">
                  <b>Deadline: </b>
                  <span>
                    {moment(getTicketResult.results?.duedate).format(
                      "DD/MM/YYYY HH:mm:ss"
                    )}
                  </span>
                </div>
                <div className="col-span-12 md:col-span-6 lg:col-span-3">
                  <b>Last response: </b>
                  <span>
                    {moment(getTicketResult.results?.updated_at).format(
                      "DD/MM/YYYY HH:mm:ss"
                    )}
                  </span>
                </div>
              </div>
            )}
          </div>
          <div className="grid grid-cols-12 gap-4 mb-4">
            {getTicketResult.results && (
              <>
                <div className="col-span-12 md:col-span-6">
                  <table className="w-full">
                    <tbody>
                      <tr className="h-10 border-t  hover:bg-neutral-200">
                        <td>
                          <b>Status :</b>
                        </td>
                        <td>{getTicketResult.results?.status_name}</td>
                      </tr>
                      <tr className="h-10 border-t  hover:bg-neutral-200">
                        <td>
                          <b>Priority :</b>
                        </td>
                        <td>{getTicketResult.results?.priority_name}</td>
                      </tr>
                      <tr className="h-10 border-t  hover:bg-neutral-200">
                        <td>
                          <b>Departement :</b>
                        </td>
                        <td>
                          {getTicketResult.results?.dept_name
                            ? getTicketResult.results.dept_name
                            : "-"}
                        </td>
                      </tr>
                      <tr className="h-10 border-t  hover:bg-neutral-200">
                        <td>
                          <b>Email :</b>
                        </td>
                        <td>{getTicketResult.results?.user_email}</td>
                      </tr>
                      <tr className="h-10 border-t  hover:bg-neutral-200">
                        <td>
                          <b>Client Name :</b>
                        </td>
                        <td>{getTicketResult.results?.client_name}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="col-span-12 md:col-span-6">
                  <table className="w-full">
                    <tbody>
                      <tr className="h-10 border-t  hover:bg-neutral-200">
                        <td>
                          <b>Source :</b>
                        </td>
                        <td>{getTicketResult.results?.source_name}</td>
                      </tr>
                      <tr className="h-10 border-t  hover:bg-neutral-200">
                        <td>
                          <b>Last Message :</b>
                        </td>
                        <td>
                          <td>{getTicketResult.results?.last_replier_name}</td>
                        </td>
                      </tr>
                      <tr className="h-10 border-t  hover:bg-neutral-200">
                        <td>
                          <b>Assigned :</b>
                        </td>
                        <td>
                          {getTicketResult.results?.assigned_to === null &&
                          getTicketResult.results?.team === null ? (
                            <span className="text-red-500">UNASSIGNED</span>
                          ) : (
                            <span className="text-green-500 dark:text-green-200">
                              {getTicketResult.results?.team_name ??
                                getTicketResult.results?.assignedto_name}
                            </span>
                          )}
                        </td>
                      </tr>
                      <tr className="h-10 border-t  hover:bg-neutral-200">
                        <td>
                          <b>{getRatingResult && getRatingResult.name} :</b>
                        </td>
                        <td>
                          <RatingButtons
                            useCancel={false}
                            item={getTicketResult.results}
                          />
                        </td>
                      </tr>
                      <tr className="h-10 border-t  hover:bg-neutral-200">
                        <td>
                          <b>ID Ticket :</b>
                        </td>
                        <td>{getTicketResult.results?.ticket_number}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
          {getTicketResult.results?.user_ban === 1 && (
            <div className="w-full flex items-center text-yellow-500 text-lg gap-1 mb-4">
              <FaBan />
              <div>This email sender ticket is under banned list</div>
            </div>
          )}
          {getTicketResult.results?.is_spam === 1 && (
            <div className="w-full flex items-center text-red-500 text-lg gap-1 mb-4">
              <FaWindowClose />
              <div className="ml-2">This Ticket is Spam, </div>
              {getTicketResult.results?.reason_spam !== null ? (
                <div>Reason : {getTicketResult.results?.reason_spam}</div>
              ) : (
                <div>Reason : Set by agent</div>
              )}
            </div>
          )}
          <div className="mb-4">
            <CardContainer title={"Actions"}>
              {getTicketResult.results?.is_spam === 1 && (
                <div className="text-center text-lg font-bold text-purple-500">
                  ---- Change not-spam to reply this message ----
                </div>
              )}
              {(getTicketResult.results?.is_spam === 0 ||
                getTicketResult.results?.is_spam === null) && (
                <div className="m-4">
                  <Tabs>
                    <TabList>
                      <Tab>
                        <div className="text-green-600">
                          <FaReplyAll className="inline" /> Reply
                        </div>
                      </Tab>
                      <Tab>
                        <div className="text-blue-600">
                          <FaElementor className="inline" /> Internal Notes
                        </div>
                      </Tab>
                    </TabList>
                    <TabPanel>
                      <form onSubmit={formikReply.handleSubmit}>
                        <div className="grid grid-cols-12 gap-4">
                          <div className="col-span-12 md:col-span-2">
                            <label className="font-bold">To :</label>
                            <span className="text-red-500"> *</span>
                          </div>
                          <div className="col-span-12 md:col-span-10">
                            {getTicketResult.results && (
                              <input
                                id="email"
                                name="email"
                                type="text"
                                value={getTicketResult.results?.user_email}
                                disabled
                                className="p-1 w-1/2 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                              />
                            )}
                            {getEmailSettingResult &&
                              getEmailSettingResult.email_collaborator ===
                                1 && (
                                <>
                                  <div className="block">
                                    <a
                                      className="text-blue-500 my-1 hover:text-blue-700 cursor-pointer"
                                      onClick={handleCc}
                                    >
                                      Add CC
                                    </a>
                                  </div>

                                  {getTicketResult.results
                                    .ticket_collaborator !== null &&
                                    getTicketResult.results?.ticket_collaborator
                                      .length > 0 && (
                                      <div className="block">
                                        <a
                                          className="text-blue-500 my-1 hover:text-blue-700 cursor-pointer"
                                          onClick={handleReceipt}
                                        >
                                          (
                                          {
                                            getTicketResult.results
                                              ?.ticket_collaborator_count
                                          }
                                          ) Recipients
                                        </a>
                                      </div>
                                    )}
                                </>
                              )}
                          </div>

                          <div className="col-span-12 md:col-span-2">
                            <label className="font-bold">Response :</label>
                          </div>
                          <div className="col-span-12 md:col-span-10">
                            <select
                              id="cannnedResponse"
                              name="cannnedResponse"
                              value={cannedResponseValue}
                              onChange={(e) => handleChangeCanned(e)}
                              className="border w-1/2 rounded-sm p-1 border-gray-300 dark:text-black focus:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-300"
                            >
                              <option value="">Select a canned response</option>
                              {getCannedResponseResult.results &&
                                getCannedResponseResult.results.map(
                                  (item, index) => (
                                    <option key={index} value={item.message}>
                                      {item.title}
                                    </option>
                                  )
                                )}
                            </select>
                          </div>

                          <div className="col-span-12 md:col-span-2">
                            <label className="font-bold">Reply content :</label>
                            <span className="text-red-500"> *</span>
                          </div>
                          <div className="col-span-12 md:col-span-10">
                            <CKEditor
                              key={refreshReply}
                              config={toolbarConfig}
                              type="classic"
                              initData={formikReply.values.body}
                              onChange={(e) => {
                                formikReply.setFieldValue(
                                  "body",
                                  e.editor.getData()
                                );
                              }}
                            />
                            {formikReply.touched.body &&
                              formikReply.errors.body && (
                                <div className="text-red-500 dark:text-red-300 text-xs">
                                  {formikReply.errors.body}
                                </div>
                              )}
                          </div>

                          <div className="col-span-12 md:col-span-2">
                            <label className="font-bold">Attachment :</label>
                          </div>
                          <div className="col-span-12 md:col-span-10">
                            <div className="flex items-center mb-2">
                              <label className="p-1 px-3 flex items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100 dark:bg-neutral-700 dark:border-neutral-700 text-gray-900 dark:text-white">
                                <FaPaperclip />
                                <span>Choose File [Accept Multiple]</span>
                                <input
                                  type="file"
                                  id="file"
                                  name="file"
                                  className="hidden"
                                  multiple // Izinkan pengguna untuk memilih beberapa file
                                  onChange={(e) => {
                                    const selectedFiles = Array.from(
                                      e.target.files
                                    );
                                    const maxSize = 5 * 1024 * 1024; // 5MB in bytes
                                    const allowedExtensions = [
                                      ".doc",
                                      ".docx",
                                      ".jpeg",
                                      ".png",
                                      ".webp",
                                      ".pdf",
                                      ".xls",
                                      ".xlsx",
                                      ".jpg",
                                      ".DOC",
                                      ".DOCX",
                                      ".JPEG",
                                      ".PNG",
                                      ".WEBP",
                                      ".PDF",
                                      ".XLS",
                                      ".XLSX",
                                      ".JPG",
                                    ];

                                    const validFiles = selectedFiles.filter(
                                      (file) => {
                                        const fileExtension = file.name
                                          .split(".")
                                          .pop();

                                        if (file.size > maxSize) {
                                          // Validasi ukuran file
                                          toast.warning(
                                            `File ${file.name} exceeds the size limit (5MB).`,
                                            {
                                              position: "top-center",
                                              autoClose: true,
                                              hideProgressBar: true,
                                              closeOnClick: true,
                                              pauseOnHover: true,
                                              draggable: true,
                                              progress: undefined,
                                              theme: "light",
                                            }
                                          );
                                          return false;
                                        } else if (
                                          !allowedExtensions.includes(
                                            `.${fileExtension.toLowerCase()}`
                                          )
                                        ) {
                                          // Validasi ekstensi file
                                          toast.warning(
                                            `File ${file.name} has an unsupported extension.`,
                                            {
                                              position: "top-center",
                                              autoClose: true,
                                              hideProgressBar: true,
                                              closeOnClick: true,
                                              pauseOnHover: true,
                                              draggable: true,
                                              progress: undefined,
                                              theme: "light",
                                            }
                                          );
                                          return false;
                                        }

                                        return true;
                                      }
                                    );

                                    // Update the 'files' array in one go
                                    formikReply.setFieldValue("files", [
                                      ...formikReply.values.files,
                                      ...validFiles,
                                    ]);
                                  }}
                                />
                              </label>
                              <p className="ml-2">
                                Each file upload is a maximum of 5Mb
                                [doc,docx,jpeg,png,webp,pdf,xls,xlsx,jpg]
                              </p>
                            </div>

                            {formikReply.values.files.map((file, index) => (
                              <div
                                key={index}
                                className="md:flex md:flex-row items-center justify-between bg-blue-100 dark:bg-blue-800 text-blue-500 dark:text-blue-100 p-2 rounded-lg mb-2 w-full lg:w-1/2"
                              >
                                <span className="mr-2 flex-wrap">
                                  {file.name} ({byteToKiloByte(file.size)} KB)
                                </span>
                                <button
                                  type="button"
                                  onClick={() => {
                                    // Hapus file dari daftar saat pengguna mengklik tombol
                                    const updatedFiles = [
                                      ...formikReply.values.files,
                                    ];
                                    updatedFiles.splice(index, 1);
                                    formikReply.setFieldValue(
                                      "files",
                                      updatedFiles
                                    );
                                  }}
                                  className="text-red-500 hover:text-red-700 ml-2 cursor-pointer"
                                >
                                  Delete
                                </button>
                              </div>
                            ))}
                          </div>

                          <div className="col-span-12 md:col-span-2"></div>
                          <div className="col-span-12 md:col-span-10">
                            <button
                              type="submit"
                              disabled={loadingSubmit}
                              className="flex p-1 px-10 items-center rounded shadow-sm border bg-green-700 hover:bg-green-800 dark:bg-green-700 dark:border-green-700 text-white dark:text-white"
                            >
                              {loadingSubmit ? (
                                <PulseLoader
                                  color="rgb(255 255 255)"
                                  size={14}
                                />
                              ) : (
                                <>Send</>
                              )}
                            </button>
                          </div>
                        </div>
                      </form>
                    </TabPanel>
                    <TabPanel>
                      <form onSubmit={formikInternalNotes.handleSubmit}>
                        <div className="grid grid-cols-12 gap-4">
                          <div className="col-span-12 md:col-span-2">
                            <label className="font-bold">Internal note :</label>
                            <span className="text-red-500"> *</span>
                          </div>
                          <div className="col-span-12 md:col-span-10">
                            <CKEditor
                              key={refreshInternalNote}
                              config={toolbarConfig}
                              type="classic"
                              initData={formikInternalNotes.values.body}
                              onChange={(e) => {
                                formikInternalNotes.setFieldValue(
                                  "body",
                                  e.editor.getData()
                                );
                              }}
                            />
                            {formikInternalNotes.touched.body &&
                              formikInternalNotes.errors.body && (
                                <div className="text-red-500 dark:text-red-300 text-xs">
                                  {formikInternalNotes.errors.body}
                                </div>
                              )}
                          </div>

                          <div className="col-span-12 md:col-span-2"></div>
                          <div className="col-span-12 md:col-span-10">
                            <button
                              type="submit"
                              disabled={loadingSubmit}
                              className="flex p-1 px-10 items-center rounded shadow-sm border bg-sky-700 hover:bg-sky-800 dark:bg-sky-700 dark:border-sky-700 text-white dark:text-white"
                            >
                              {loadingSubmit ? (
                                <PulseLoader
                                  color="rgb(255 255 255)"
                                  size={14}
                                />
                              ) : (
                                <>Send</>
                              )}
                            </button>
                          </div>
                        </div>
                      </form>
                    </TabPanel>
                  </Tabs>
                </div>
              )}
            </CardContainer>
          </div>

          <div>
            <CardContainer title={"Ticket Conversation"}>
              <div className="m-4">
                <ol className="relative list-none ml-8 border-l-4 border-gray-200 dark:border-gray-700 text-sm">
                  {getTicketResult.results !== undefined &&
                    Array.isArray(getTicketResult.results.ticket_thread) &&
                    getTicketResult.results.ticket_thread.map((item, index) => {
                      // Mendapatkan item sebelumnya
                      const previousItem =
                        index > 0
                          ? getTicketResult.results.ticket_thread[index - 1]
                          : null;

                      const currentDate = moment(item.created_at).format(
                        "DD/MM/YYYY"
                      );
                      const previousDate = previousItem
                        ? moment(previousItem.created_at).format("DD/MM/YYYY")
                        : null;

                      return (
                        <div key={index}>
                          <li className="mb-8 ml-6">
                            {/* history datetime */}
                            {(!previousDate ||
                              currentDate !== previousDate) && (
                              <span className="relative flex items-center px-1 justify-center h-7 -left-16 ring-8 ring-white font-normal bg-green-600 w-fit rounded text-white dark:text-white dark:ring-gray-900 dark:bg-blue-900">
                                {currentDate}
                              </span>
                            )}
                          </li>
                          <li className="mb-10 ml-6 border rounded-md bg-gray-100 dark:bg-neutral-700">
                            {/* Icon user */}
                            {item.group_names === "user" && (
                              <span
                                title="Posted by Customer"
                                className="absolute flex items-center justify-center w-7 h-7 bg-blue-100 rounded-full -left-4 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900"
                              >
                                <FaUser />
                              </span>
                            )}
                            {/* Icon Tag  */}
                            {item.is_internal === 1 && (
                              <span
                                title="Posted by System"
                                className="absolute flex items-center justify-center w-7 h-7 bg-purple-500 rounded-full -left-4 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900"
                              >
                                <FaTag className="text-white" />
                              </span>
                            )}

                            {/* Icon Reply */}
                            {item.group_names === "agent" &&
                              item.is_internal !== 1 && (
                                <span
                                  title="Posted by Support Team"
                                  className="absolute flex items-center justify-center w-7 h-7 bg-yellow-400 rounded-full -left-4 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900"
                                >
                                  <FaReplyAll />
                                </span>
                              )}

                            {/* Title  */}
                            <div className="p-1 px-2 flex flex-wrap justify-between items-center border  dark:bg-neutral-800">
                              <div className="flex flex-wrap items-center mb-1 text-lg font-semibold text-gray-900 dark:text-white">
                                <img
                                  className="mr-2 w-7 h-7 rounded-full border-2 border-gray-400"
                                  src={item.avatar}
                                />
                                <p
                                  onClick={() => HandlePreviewUser(item.user)}
                                  className="text-blue-500 hover:text-blue-700 cursor-pointer"
                                >
                                  {item.client_name}
                                </p>

                                {/* Terbaru  */}
                                {index === 0 && (
                                  <span className="bg-blue-100 text-blue-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300 ml-3">
                                    New
                                  </span>
                                )}
                              </div>
                              <div className="flex flex-wrap items-center">
                                {item.is_internal === 1 && (
                                  <p
                                    title="Internal Records that can only be viewed by Agents"
                                    className="text-blue-500 mr-3 flex items-center"
                                  >
                                    <FaElementor className="mr-0.5" />
                                    Internal
                                  </p>
                                )}
                                {getTicketResult?.results?.source !== 8 &&
                                  item.group_names === "agent" &&
                                  item.is_internal !== 1 && (
                                    <>
                                      {((item.reply_send !== 1 &&
                                        item.reply_send !== 0) ||
                                        (isMoreThan5MinutesAgo(
                                          item.updated_at
                                        ) &&
                                          item.reply_send === 0)) && (
                                        <button
                                          onClick={() => HandleResend(item.id)}
                                          title="Resend Email Reply to client"
                                          className="mr-2 flex p-1 px-3 items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100 dark:bg-neutral-700 dark:border-neutral-700 text-gray-900 dark:text-white"
                                        >
                                          Re-send
                                        </button>
                                      )}
                                      <p
                                        title="Status Send Email Reply to Client"
                                        className={` ${
                                          item.reply_send === 0
                                            ? "text-blue-500"
                                            : item.reply_send === 1
                                            ? "text-green-500"
                                            : "text-red-500"
                                        }  mr-3 flex items-center`}
                                      >
                                        <FaMailBulk className="mr-0.5" />
                                        {item.reply_send === 0
                                          ? "Pending"
                                          : item.reply_send === 1
                                          ? "Success"
                                          : "Failed"}
                                      </p>
                                    </>
                                  )}
                                <FaRegClock className="mr-1 text-gray-400" />
                                <p className="block text-sm font-normal text-gray-400 dark:text-gray-500">
                                  {moment(item.created_at).format(
                                    "DD MMMM YYYY, HH:mm:ss"
                                  )}
                                </p>
                              </div>
                            </div>

                            {/* content  */}
                            <div className="p-1 px-4 mb-4 mt-3  text-base font-normal text-black dark:text-white">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.body_view,
                                }}
                                className="block mb-4 ck-editor-content text-sm"
                              ></div>
                              <div className="flex flex-wrap gap-4">
                                <PhotoProvider>
                                  {item.ticket_attachment &&
                                    item.ticket_attachment.map(
                                      (item, index) => (
                                        <div
                                          key={index}
                                          className="border-2 min-w-min text-center "
                                        >
                                          <div
                                            className={`border-b h-10 flex justify-center items-center ${getColorClass(
                                              getExtensionFile(item.name)
                                            )}`}
                                          >
                                            {getIcon(
                                              getExtensionFile(item.name)
                                            )}
                                            {capitalAllLetters(
                                              getExtensionFile(item.name)
                                            )}
                                          </div>
                                          {getExtensionFile(item.name) ===
                                            "jpg" ||
                                          getExtensionFile(item.name) ===
                                            "png" ||
                                          getExtensionFile(item.name) ===
                                            "webp" ||
                                          getExtensionFile(item.name) ===
                                            "jpeg" ? (
                                            <PhotoView
                                              key={index}
                                              src={`${base}${item.name}`}
                                            >
                                              <img
                                                src={`${base}${item.name}`}
                                                className="w-40 h-36 cursor-pointer"
                                                alt={item.name}
                                              />
                                            </PhotoView>
                                          ) : (
                                            <a
                                              className="text-center px-4 text-xs md:text-base hover:text-blue-600"
                                              href={`${base}${item.name}`}
                                              target="_blank"
                                            >
                                              {removeTicketPrefix(item.name)}
                                            </a>
                                          )}
                                          <div className="text-xs md:text-base">
                                            {byteToKiloByte(item.size)} KB
                                          </div>
                                        </div>
                                      )
                                    )}
                                </PhotoProvider>
                              </div>
                            </div>

                            {/* history icon  */}
                            {index ===
                              getTicketResult.results?.ticket_thread.length -
                                1 &&
                              getTicketResult.next === null && (
                                <span
                                  title="Start Ticket"
                                  className="absolute flex items-center justify-center w-7 h-7 bg-gray-600 rounded-full -left-4 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900"
                                >
                                  <FaHistory className="text-white" />
                                </span>
                              )}
                          </li>
                        </div>
                      );
                    })}
                </ol>
              </div>
            </CardContainer>
          </div>
          <div className="pt-5 py-11">
            <CompPagination
              handlePageClick={(e) => handlePageClick(e)}
              pageCount={getTicketResult.count > 0 ? getTicketResult.count : 0}
              limit={limit}
              offset={offset}
              currentPage={currentPage}
            />
          </div>
        </div>
        {/* Modal */}
        <div>
          <ModalEditTicket
            isOpen={modalEditTicket}
            onClose={closeModalEdit}
            item={itemModalEditTicket}
            callback={() => handleFetch()}
          />
          <ModalAssign
            isOpen={openModalAssign}
            onClose={HandleCloseAssign}
            item={state.id}
            callback={() => handleFetch()}
          />
          <ModalChangeOwner
            isOpen={openModalChangeOwner}
            onClose={handleCloseModalChangeOwner}
            item={state.id}
            callback={() => handleFetch()}
          />
          <ModalBanEmail
            isOpen={openModalBanEmail}
            onClose={HandleCloseBanEmail}
            item={{
              id_user: getTicketResult.results?.user,
              email: getTicketResult.results?.user_email,
            }}
            callback={() => handleFetch()}
          />
          <ModalAddCC
            isOpen={openModalCC}
            onClose={handleCloseCc}
            item={state.id}
            callback={() => handleFetch()}
          />
          <ModalReceipt
            isOpen={openModalReceipt}
            onClose={handleCloseReceipt}
            item={state.id}
            callback={() => handleFetch()}
          />
        </div>
      </CardContainer>
    </Container>
  );
};

export default TicketDetail;
